module.exports = __webpack_public_path__ + "static/media/groupe.cef1aa9c.jpg";